<template>
    <div>
        <b-collapse visible>
            <b-card>
                <VehicleActions :label="selectedVehicle"/>
            </b-card>
        </b-collapse>
        <div><EventTable @eventSelected="onEventSelected"/></div>
    </div>
    
</template>

<script>
import EventTable from '@/components/Dispatching/Events/EventTable'
import VehicleActions from '@/components/Realtime/VehicleActions'

export default {
    name: "Events",
    components: {
        EventTable, VehicleActions
    },
    data: function() {
        return {
            currentEvent: null,
            vehicles: [ "1001","1008"]
        }
    },
    computed: {
        currentEventAddress() {
            return this.currentEvent?.eventSource
        },
        selectedVehicle() {
            if( this.currentEvent?.eventSource?.type == 'VEHICLE' )
                return this.currentEvent?.eventSource.id
            return null
        }
        
    },
    methods: {
        onEventSelected(event) {
            this.currentEvent=event
        }
    }    
}
</script>

<style scoped>
.phoneview {
    height: 5em;
}
div.search-options {
    max-width: 200px;
}
</style>